import React from 'react'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@material-ui/core/index'
import { strings } from '../../../../localization/strings'
import Loader from '../../../loaders/dots_loader/index'
import { orderReturn } from '../../../../helpers/restHelpers'

class Component extends React.Component {
    state = { open: false, loading: false }

    handleClickOpen = () => {
        this.setState({ open: true })
    }

    handleClose = (force) => {
        if (force !== true) {
            if (this.state.loading) return
        }
        this.setState({ open: false, loading: false })
    }

    confirm = () => {
        this.setState({ loading: true })

        orderReturn(this.props.order.id)
            .then(() => {
                this.handleClose(true)
                window.showDialog(
                    {
                        title: strings.orderReturnSuccessTitle,
                        message: strings.orderReturnSuccess,
                    },
                    () => this.props.actionDone()
                )
            })
            .catch((error) => {
                this.handleClose(true)
                window.showDialog(error)
            })
    }

    render() {
        const { lockerName, address, shippingMethodId } = this.props.order

        return (
            <div style={{ width: '100%' }}>
                <div onClick={this.handleClickOpen}>
                    {strings.orderReturnButton}
                </div>
                <Dialog
                    open={this.state.open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {strings.orderReturnDialogTitle}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText
                            id="alert-dialog-description"
                            style={{ whiteSpace: 'pre-line' }}
                        >
                            {strings.orderReturnDialogText}
                            {lockerName || address ? (
                                <p
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                    }}
                                >
                                    {shippingMethodId === 1 ? (
                                        <strong>
                                            {
                                                strings.orderReturnDialogLockerTextInfo
                                            }
                                        </strong>
                                    ) : null}
                                    {shippingMethodId === 3 ? (
                                        <strong>
                                            {
                                                strings.orderReturnDialogShipToAddressTextInfo
                                            }
                                        </strong>
                                    ) : null}
                                    {!lockerName ? null : (
                                        <span>
                                            {strings.locker + ': ' + lockerName}
                                        </span>
                                    )}
                                    {!address ? null : (
                                        <span>
                                            {strings.address + ': ' + address}
                                        </span>
                                    )}
                                </p>
                            ) : null}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.handleClose}
                            color="primary"
                            disabled={this.state.loading}
                        >
                            {strings.close}
                        </Button>
                        <Button
                            onClick={this.confirm}
                            color="primary"
                            autoFocus
                            disabled={this.state.loading}
                        >
                            {strings.continue}
                        </Button>
                    </DialogActions>
                    {this.state.loading ? <Loader /> : null}
                </Dialog>
            </div>
        )
    }
}

export default Component
